import React, { useState, useEffect } from "react";
import { API_URL } from "../helpers";
import Alert from "../components/Alert";
import Msg from "../components/Msg";

const Uploaded = ({ src, name, remove }) => {
  return (
    <div className="uploaded">
      <div>
        <button type="button" onClick={(e) => remove(name)}>
          <i className="fa fa-times fa-lg" />
        </button>
      </div>
      <img src={src} alt={name} />
    </div>
  );
};

const Uploading = () => {
  return (
    <label className="uploading">
      <i className="fa fa-circle-o-notch fa-spin fa-3x" />
    </label>
  );
};

const Upload = ({ name, update }) => {
  return (
    <label htmlFor={name}>
      <i className="fa fa-upload fa-3x" />
      <input
        type="file"
        id={name}
        name={name}
        style={{ display: "none" }}
        onChange={(e) => update(name, e.target.files[0])}
      />
    </label>
  );
};

const Form3 = ({ token, update }) => {
  const [names, setNames] = useState({
    token,
    img1: {
      status: 0,
      url: "",
    },
    img2: {
      status: 0,
      url: "",
    },
    img3: {
      status: 0,
      url: "",
    },
  });
  const [photo, setPhoto] = useState(null);
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  useEffect(() => {
    init();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (photo) {
      handleUpload();
    }

    // eslint-disable-next-line
  }, [photo]);

  const init = async () => {
    const url = new URL(`${API_URL}/auth/charityForm3Init`);
    const params = {
      token: names.token,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        if (json.img1) {
          handleUpdate("img1", { status: 1, url: json.img1 });
        }
        if (json.img2) {
          handleUpdate("img2", { status: 1, url: json.img2 });
        }
        if (json.img3) {
          handleUpdate("img3", { status: 1, url: json.img3 });
        }
        setAlert({});
      } else {
        setAlert({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    if (name === "1" || name === "2" || name === "3") {
      if (value.size > 5000000) {
        setMsg({
          type: "error",
          text: "Please limit photo upload size to 5 MB.",
        });
        return false;
      } else {
        setNames((names) => ({ ...names, img: name }));
        setPhoto(value);
      }
    } else {
      setNames((names) => ({ ...names, [name]: value ? value : "" }));
    }
  };

  const handleUpload = async () => {
    setMsg({});
    handleUpdate(`img${names.img}`, { status: 2, url: "" });

    const url = new URL(`${API_URL}/auth/charityForm3`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "remove") {
        data.append(key, value ? "1" : "0");
      } else if (key === "img1" || key === "img2" || key === "img3") {
      } else {
        data.append(key, value);
      }
    });
    data.append("photo", photo);

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        handleUpdate(`img${json.img}`, { status: 1, url: json.url });
      } else {
        handleUpdate(`img${names.img}`, { status: 0, url: "" });
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      handleUpdate(`img${names.img}`, { status: 0, url: "" });
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleRemove = async (img) => {
    setMsg({});
    handleUpdate(`img${names.img}`, { status: 2, url: "" });

    const url = new URL(`${API_URL}/auth/charityForm3Remove`);
    let data = new FormData();
    data.append("img", img);
    data.append("token", token);

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        if (json.img1) {
          handleUpdate("img1", { status: 1, url: json.img1 });
        } else {
          handleUpdate("img1", { status: 0, url: "" });
        }
        if (json.img2) {
          handleUpdate("img2", { status: 1, url: json.img2 });
        } else {
          handleUpdate("img2", { status: 0, url: "" });
        }
        if (json.img3) {
          handleUpdate("img3", { status: 1, url: json.img3 });
        } else {
          handleUpdate("img3", { status: 0, url: "" });
        }
        setAlert({});
      } else {
        handleUpdate(`img${img}`, { status: 0, url: "" });
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      handleUpdate(`img${names.img}`, { status: 0, url: "" });
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <form
          method="post"
          action="/"
          onSubmit={(e) => {
            e.preventDefault(e);
            handleUpload("1");
          }}
          className="well"
        >
          <h3 style={{ marginTop: "0" }}>Upload Photos</h3>

          <p>Use the form below to add up to 3 photos to your donation page.</p>

          <div className="image-grid">
            <div>
              {names.img1.status === 1 ? (
                <Uploaded src={names.img1.url} name="1" remove={handleRemove} />
              ) : names.img1.status === 2 ? (
                <Uploading />
              ) : (
                <Upload name="1" update={handleUpdate} />
              )}
            </div>

            <div>
              {names.img2.status === 1 ? (
                <Uploaded src={names.img2.url} name="2" remove={handleRemove} />
              ) : names.img2.status === 2 ? (
                <Uploading />
              ) : (
                <Upload name="2" update={handleUpdate} />
              )}
            </div>

            <div>
              {names.img3.status === 1 ? (
                <Uploaded src={names.img3.url} name="3" remove={handleRemove} />
              ) : names.img3.status === 2 ? (
                <Uploading />
              ) : (
                <Upload name="3" update={handleUpdate} />
              )}
            </div>
          </div>

          <div className="msg-submit">{msg.type && <Msg data={msg} />}</div>
        </form>
      )}
    </>
  );
};

export default Form3;
